import { Attribute } from '../../Attribute';
import { AttributeValueInstance, AttributeValueOrNumber } from './AttributeValueInstance';

export class NumericValueInstance extends AttributeValueInstance<number> {
  constructor(attributeValue: number) {
    super(attributeValue);
  }
}
